import { PropTypes, globalAttributesPropTypes, xstyledPropTypes } from '@elliemae/ds-props-helpers';
import { MOBILE_BANNER_TYPES } from './utils/bannerTypes.js';

type MobileBannerTypesT = (typeof MOBILE_BANNER_TYPES)[keyof typeof MOBILE_BANNER_TYPES];

export const defaultProps = {
  type: MOBILE_BANNER_TYPES.SUCCESS,
  isOpen: false,
  closeButtonOnClick: () => null,
  actionLinkLabel: null,
  actionLinkHref: null,
  actionLinkOnClick: () => null,
  label: '',
  body: '',
  showCloseButton: true,
  containerProps: {},
  focusOnOpen: false,
};

export declare namespace DSMobileBannerT {
  export interface DefaultProps {
    type: MobileBannerTypesT;
    isOpen: boolean;
    closeButtonOnClick: () => void | null;
    actionLinkLabel: string;
    actionLinkHref: string;
    actionLinkOnClick: () => void | null;
    label: string;
    body: string;
    showCloseButton?: boolean;
    containerProps: Record<string, unknown>;
    focusOnOpen?: boolean;
  }

  export interface PropsOptional {}

  export interface PropsRequired {}

  export interface Props extends PropsOptional, PropsRequired, DefaultProps {}
  export interface InternalProps extends PropsOptional, PropsRequired, Required<DefaultProps> {}
}

export const propTypes = {
  ...globalAttributesPropTypes,
  ...xstyledPropTypes,
  type: PropTypes.oneOf(['info', 'success', 'warning', 'error'])
    .description('Type of banner')
    .defaultValue(defaultProps.type),
  isOpen: PropTypes.bool.description('Whether the banner is open or not').defaultValue(defaultProps.isOpen),
  closeButtonOnClick: PropTypes.func
    .description('OnClick function used in the close button')
    .defaultValue(defaultProps.closeButtonOnClick),
  actionLinkLabel: PropTypes.string
    .description('Label used in the the action link')
    .defaultValue(defaultProps.actionLinkLabel),
  actionLinkHref: PropTypes.string
    .description('Href used in the the action link')
    .defaultValue(defaultProps.actionLinkLabel),
  actionLinkOnClick: PropTypes.func
    .description('OnClick function used in the action link')
    .defaultValue(defaultProps.actionLinkOnClick),
  label: PropTypes.string.description('Label text for the banner').defaultValue(defaultProps.label),
  body: PropTypes.string.description('Body text for the banner').defaultValue(defaultProps.body),
  showCloseButton: PropTypes.bool
    .description('Whether the close button should be visible or not')
    .defaultValue(defaultProps.showCloseButton),
  containerProps: PropTypes.shape({})
    .description('Set of properties attached to the banner container')
    .defaultValue(defaultProps.containerProps),
  focusOnOpen: PropTypes.bool
    .description(
      "Whether the banner should get focus when its openedWhether the banner should get focus when it's opened",
    )
    .defaultValue(defaultProps.focusOnOpen),
};
